import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { usePartDetails } from '@v2/pages/common/hooks/usePartDetails';
import { connect } from 'react-redux';
import { getNCFileByPartId } from '@reducers/manufacture';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { getProductionBatchByPart, operationsSearch } from '@reducers/search';
import { getPartByID } from '@reducers/parts';
import { ImagesDocumentsContent } from '@v2/pages/nc-file/details/modules/nc-file/components/ImagesDocumentsContent';
import { DOCUMENT_ENTITY_TYPE } from '@components/imageHandling/common';
import { View } from 'react-native';
import { DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';

interface PartDetailsJobsDocumentsProps {
  jobId: number | null;
}

const PartDetailsJobsDocumentsComponent: FC<PartDetailsJobsDocumentsProps> = ({
  clearTools,
  getTools,
  updateHeaderConfig,
  getProductionBatchByPart,
  getPartByID,
  getNCFileByPartId,
  operationsSearch,
  jobId,
}) => {
  const title = useTitle();

  usePartDetails({
    clearTools,
    getNCFileByPartId,
    getTools,
    updateHeaderConfig,
    getProductionBatchByPart,
    getPartByID,
    operationsSearch,
    getAllJobs: true,
  });

  return (
    <DetailsPageWrapper title={title.job}>
      {jobId != null && (
        <View style={DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES}>
          <ImagesDocumentsContent documentRetrieveId={jobId} documentRetrieveKey={DOCUMENT_ENTITY_TYPE.ProductionOperation} />
        </View>
      )}
    </DetailsPageWrapper>
  );
};

const PartDetailsJobsDocuments = connect(({ details: { jobId } }) => ({ jobId }), {
  clearTools,
  getNCFileByPartId,
  getTools,
  updateHeaderConfig,
  getProductionBatchByPart,
  getPartByID,
  operationsSearch,
})(PartDetailsJobsDocumentsComponent);

export { PartDetailsJobsDocuments };
